import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { respuestapregunta } from '../../../../shared/models/respuesta';

@Component({
  selector: 'pregunta',
  templateUrl: './pregunta.component.html',
  styleUrls: ['./pregunta.component.scss'],
})
export class PreguntaComponent implements OnInit {

  @Input() setPregunta: string
  @Input() setPregunta2: string
  @Input() idCalificaPregunta: number
  @Input() idCalificaRegion: number
  @Input() idTendero: number
  @Input() isEnabled: any

  @Output() valueEmit = new EventEmitter<respuestapregunta>()

  public longitud = 0
  public respuesta = {
    ID_CalificaPregunta: 0,
    ID_TenderoRegistro: 0,
    Valor: 10,
    Observaciones: ''
  }

  constructor() { }

  ngOnInit() {
    this.respuesta.ID_CalificaPregunta = this.idCalificaPregunta
    this.respuesta.ID_TenderoRegistro = this.idTendero
  }

  cambioCaritas(event: any) {
    this.respuesta.Valor = event.valor
    this.isEnabled = false
    this.emitir()
  }

  cambioTexto(event: any) {
    this.respuesta.Observaciones = event.texto
    this.longitud = event.texto.length
    this.emitir()
  }

  emitir() {
    if (this.respuesta.Valor !== 10) {
      this.valueEmit.emit(this.respuesta)
    }
  }
}
